import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';

import dynamic from 'next/dynamic';
import CatalogTitleHeading from 'components/CatalogTitleHeading';
import styles from './styles.module.scss';

const EmptyMessage = dynamic(() => import('./components/EmptyMessage'), {
	ssr: false
});

const Catalog = ({
	controls,
	controlsTop,
	footer,
	emptyMessage,
	children,
	pageTitle,
	total
}) => (
	<div className={styles.catalog}>
		{controlsTop && <div className={styles.block}>{controlsTop}</div>}
		{pageTitle && (
			<div className={styles.block}>
				<CatalogTitleHeading headingTitle={pageTitle} total={total} />
			</div>
		)}
		{!_.isEmpty(controls) && <div className={styles.block}>{controls}</div>}
		{!_.isEmpty(children) ? (
			<div className={styles.block}>{children}</div>
		) : (
			<EmptyMessage {...{ emptyMessage }} />
		)}
		{!_.isEmpty(footer) && <div className={styles.footer}>{footer}</div>}
	</div>
);

Catalog.propTypes = {
	controls: PropTypes.node,
	controlsTop: PropTypes.node,
	footer: PropTypes.node,
	emptyMessage: PropTypes.string,
	pageTitle: PropTypes.string,
	children: PropTypes.node,
	total: PropTypes.number
};

Catalog.defaultProps = {
	emptyMessage: 'К сожалению, по вашему запросу ничего не найдено'
};

export default Catalog;
